{
  "dodo.common.close": "Close",
  "dodo.common.continue": "Continue",
  "dodo.errors.idle.action": "Erneut versuchen",
  "dodo.errors.idle.headline": "Service derzeit nicht verfügbar",
  "dodo.errors.idle.line1": "Bitte versuche es später noch einmal.",
  "dodo.feedback.comments": "Please share any additional comments, suggestions or improvement opportunities. How it can be more valuable to you?",
  "dodo.feedback.description": "Your feedback is very important, so we can improve our services",
  "dodo.feedback.disclaimer.headline": "No worries, your answer will be anonymised!",
  "dodo.feedback.disclaimer.line1": "Your name and e-mail won't be linked to your answer.",
  "dodo.feedback.headline": "On a scale from 1-5, how satisfied are you with {subject}?",
  "dodo.feedback.placeholder": "Write your feedback here",
  "dodo.feedback.satisfied": "Very satisfied",
  "dodo.feedback.success.line1": "Thanks for using and contributing to our services.",
  "dodo.feedback.success.title": "Your feedback was successfully registered",
  "dodo.feedback.unsatisfied": "Very unsatisfied",
  "dodo.maintenance.actionText": "Zurück zur Startseite",
  "dodo.maintenance.description": "Manchmal benötigen wir eine kurze Pause, um wesentliche Wartungsarbeiten und/oder Upgrades an unseren Dienstleistungen durchzuführen. Wir danken für Ihr Verständnis.",
  "dodo.maintenance.headline": "Entschuldigung, wir führen planmäßige Wartungsarbeiten durch"
}